<div class="header-contacts">
  <ul class="header-contacts__list row-1140">
    <li>
      <span class="material-symbols-outlined" aria-hidden="true">call</span>
      <p><a href="tel:1142237590">(11) 4223-7590</a> <span>Capital e Grande SP</span></p>
    </li>
    <li>
      <span class="material-symbols-outlined" aria-hidden="true">call</span>
      <p><a href="tel:08005775777">0800-577-5777</a> <span>Demais Localidades</span></p>
    </li>
    <li>
      <span class="material-symbols-outlined" aria-hidden="true">call</span>
      <p>
        <a [href]="whatsappUrl" target="_blank" rel="noopener">(11) 4223-7590</a>
        <span>WhatsApp</span>
      </p>
    </li>
  </ul>
</div>
